<template>
  <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100 p-2" id="sidenav-collapse-main">
    <ul class="navbar-nav mt-4">
      <li class="nav-item m-0" key="profile">
        <router-link class="nav-link text-analiza-light2 p-3 mb-3" :to="{ name: 'Home' }">
          <i class="fas fa-table-cells icon me-4 ps-3" style="vertical-align:top;"></i> Panel
        </router-link>
      </li>
      <li class="nav-item m-0" key="financiero" v-if="empresa!=''">
        <router-link class="nav-link text-analiza-light2 p-3 mb-3" :to="{ name: 'Financiero' }">
          <i class="fas fa-line-chart icon me-4 ps-3"></i> Financiero
        </router-link>
      </li>
      
      <!--
      <li class="nav-item" key="usuarios">
        <a href="#" class="nav-link" @click.prevent="toggleUsuarios">
          <div class="text-center bg-analiza-light shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
            <i class="fas fa-users"></i>
          </div>
          <span class="nav-link-text ms-1">Usuarios</span>
        </a>
        <! -- HIJOS -- >
        <ul class="nav flex-column ms-4 submenu" v-show="usuariosOpen">
          <li class="nav-item">
            <sidenav-collapse navText="Listado de usuarios" :to="{ name: 'Usuarios' }" />
          </li>
          <li class="nav-item">
            <sidenav-collapse navText="Listado de roles" :to="{ name: 'Roles' }" />
          </li>
        </ul>
      </li>-->


    </ul>
    <div class="navbar-usuario ms-3">
      <div class="nav-link p-0">
        <span class="iniciales-usuario bg-analiza-medium shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
          {{ $store.state.profile.permisos?.iniciales }}
        </span>
        <p class="text-analiza-light2 m-0">{{ $store.state.profile.permisos?.nombre }}
          <span style="text-sm">{{ $store.state.profile.permisos?.farmaciaNombre ? $store.state.profile.permisos.farmaciaNombre : $store.state.profile.permisos?.empresaNombre }}</span>
        </p>
        <i class="fas fa-arrow-right-from-bracket text-analiza-light2" aria-hidden="true" @click="logoutUser"></i>
      </div>
    </div>
  </div>
</template>
<script>
//import SidenavCollapse from "./SidenavCollapse.vue";
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      controls: "dashboardsExamples",
      empresa: ''
    };
  },
  components: {
  //  SidenavCollapse,
  },
  mixins: [globalFunctionsMixin],
  methods: {
    async logoutUser() {
      try {
        await this.$store.dispatch("auth/logout");
      } finally {
        localStorage.clear();
        this.$router.push("/login");
      }
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
  async created() {
    this.empresa = await this.leerLocalStorage("datosEmpresa");
  }
};
</script>
